module.exports = __webpack_public_path__ + "img/dostoievski.f374adf9.jpg";